import SubjectPickerViewState from '../store/schema/SubjectPickerViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { ComposeControl } from 'owa-mail-compose-store/lib/utils/getAutoFocusControl';

export default function createSubjectPickerViewState(options: {
    supportsSubjectPicker: boolean;
    isPickerOpened?: boolean;
    isLoadingConversation?: boolean;
    showBackButton?: boolean;
    isBackButtonHovered?: boolean;
    initialToRecipient?: ReadWriteRecipientViewState | null;
    nextFocusControl?: ComposeControl | null;
    initialContent?: string | null;
}): SubjectPickerViewState {
    return {
        supportsSubjectPicker: options.supportsSubjectPicker,
        isPickerOpened: options.isPickerOpened,
        isLoadingConversation: options.isLoadingConversation,
        showBackButton: options.showBackButton,
        isBackButtonHovered: options.isBackButtonHovered,
        initialToRecipient: options.initialToRecipient,
        nextFocusControl: options.nextFocusControl,
        initialContent: options.initialContent,
    };
}
